var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1712838861047,
    className: "icon",
    viewBox: "0 0 1382 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 7818,
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1353.8048 172.8512l-793.856 821.0432c-0.1792 0.1792-0.5888 0.3072-0.7936 0.5888-0.2816 0.2048-0.2816 0.6144-0.6144 0.8192-6.3232 6.2976-14.1568 10.1376-21.504 14.4128-3.6608 2.1248-6.6304 5.376-10.496 6.912a96.2816 96.2816 0 0 1-74.5472-0.2048c-3.968-1.7408-7.168-5.1968-10.9056-7.3472-7.3472-4.2496-14.9504-7.9872-21.3248-14.3872-0.1792-0.1792-0.2816-0.6144-0.512-0.7936-0.1792-0.3072-0.5888-0.3072-0.768-0.6144L28.032 582.7584a103.0912 103.0912 0 0 1 1.9968-143.4112 97.536 97.536 0 0 1 140.2112 2.048L490.1632 777.728 1212.9024 30.1568a97.4848 97.4848 0 0 1 140.1856-0.8192c38.7584 39.4496 39.168 103.68 0.7168 143.5136z",
    fill: "#2c2c2c",
    "p-id": 7819
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.3b4d336cd16a4ce645ddca069bc35f50.svg";
export { ForwardRef as ReactComponent };